import { render, staticRenderFns } from "./PublicList.vue?vue&type=template&id=0c7c3358&scoped=true"
import script from "./PublicList.vue?vue&type=script&lang=js"
export * from "./PublicList.vue?vue&type=script&lang=js"
import style0 from "./PublicList.vue?vue&type=style&index=0&id=0c7c3358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c3358",
  null
  
)

export default component.exports